<template>
  <div class="my-container">
    <div class="close" @click="handleClose"><auth-img :src="closeImg" /></div>
    <a-tabs
      type="card"
      v-model:activeKey="activeKey"
      class="tabs"
      @change="handleChange"
      :tabBarGutter="2"
    >
      <a-tab-pane v-for="item in commonwordsList" :key="item.id" :tab="item.phraseName">
        <ul class="tabs-content">
          <li
            v-for="it in item.listNode"
            :key="it.id"
            @click="handleClick(it)"
            :class="{ actived: activeID === it.id }"
          >
            <div v-html="brightenKeyword(it.chatContent)" class="text-ellipsis"></div>
          </li>
        </ul>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script setup>
import { ref, defineProps, watch, onMounted, defineEmits } from 'vue'
import closeImg from '@/assets/img/chat/close.png'
const props = defineProps({
  keyword: {
    type: String,
    defalult: false
  },
  commonwordsList: {
    type: Array,
    defalult: [],
    required: true
  },
  visible: {
    type: Boolean,
    defalult: false
  }
})
const emits = defineEmits(['handlePick', 'closePopover'])
watch(
  () => props.visible,
  val => {
    if (!val) return
    activeID.value = null
    activeKey.value = props.commonwordsList[0].id
  }
)
onMounted(() => {
  activeKey.value = props.commonwordsList[0].id
})
const activeKey = ref('1')
const activeID = ref(null)

const handleClick = it => {
  activeID.value = it.id
  emits('handlePick', it)
}
const handleChange = () => {
  activeID.value = null
}
const brightenKeyword = val => {
  const keyword = props.keyword
  const Reg = new RegExp(keyword, 'i')
  let res = val
  if (val) {
    res = val.replace(Reg, `<span style="color: #FFA940;">${keyword}</span>`)
  }
  return res
}
const handleClose = () => {
  emits('closePopover')
}
</script>
<style scoped lang="scss">
.my-container {
  position: relative;
  .close {
    position: absolute;
    top: 7px;
    right: 0;
    width: 20px;
    height: 20px;
    z-index: 99;
    img {
      width: 100%;
      cursor: pointer;
    }
  }
  //   background-color: white;
  .tabs {
    ::v-deep(.ant-tabs-bar) {
      margin-bottom: initial;
    }
    ::v-deep(.ant-tabs-tab) {
      margin-right: initial;
    }

    ::v-deep(.ant-tabs-tab:first-child) {
      margin-left: initial;
    }
    ::v-deep(.ant-tabs-tabpane) {
      background: initial;
      //!NOTE: 每个tab页高度设置死不设置的话 超出部分会出现滚动条，避免滚动条出现（一屏幕）
      height: auto;
      overflow: hiden;
    }
    ::v-deep(.ant-tabs-tabpane.ant-tabs-tabpane-inactive) {
      height: 0;
    }
  }
  .tabs-content {
    padding: 12px;
    list-style: none;
    background-color: white;
    margin-bottom: initial;
    // width: 500px;
    height: 160px;
    li {
      cursor: pointer;
      margin-bottom: 5px;
      word-wrap: nob;
      font-weight: 400;
      color: #333333;
      &:hover {
        background: #f5f5f5;
        color: #000000;
      }
      &.actived {
        background-color: #eaf4ff;
      }
    }
  }
}
</style>
